var _circle, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgAlarmItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    fill: "#E8F4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.375 24.625L12.5 24.625C11.9477 24.625 11.5 24.1773 11.5 23.625L11.5 20.25L9.75 18.5L11.5 16.75L11.5 13.375C11.5 12.8227 11.9477 12.375 12.5 12.375L25.375 12.375C25.9273 12.375 26.375 12.8227 26.375 13.375L26.375 23.625C26.375 24.1773 25.9273 24.625 25.375 24.625Z",
    stroke: "#6EA7DB",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 18.5C20.25 19.2249 19.6624 19.8125 18.9375 19.8125C18.2126 19.8125 17.625 19.2249 17.625 18.5C17.625 17.7751 18.2126 17.1875 18.9375 17.1875C19.6624 17.1875 20.25 17.7751 20.25 18.5Z",
    fill: "#6EA7DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 18.5C16.3125 19.2249 15.7249 19.8125 15 19.8125C14.2751 19.8125 13.6875 19.2249 13.6875 18.5C13.6875 17.7751 14.2751 17.1875 15 17.1875C15.7249 17.1875 16.3125 17.7751 16.3125 18.5Z",
    fill: "#6EA7DB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1875 18.5C24.1875 19.2249 23.5999 19.8125 22.875 19.8125C22.1501 19.8125 21.5625 19.2249 21.5625 18.5C21.5625 17.7751 22.1501 17.1875 22.875 17.1875C23.5999 17.1875 24.1875 17.7751 24.1875 18.5Z",
    fill: "#6EA7DB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgAlarmItem);
export default __webpack_public_path__ + "static/media/img_alarm_item.f16f40eb223e74536b28321dda8a31fb.svg";
export { ForwardRef as ReactComponent };